<template>
  <div class="flex justify-between">
    <div class="composite-title" :style="{ color: color }">
      {{ questionData.question[lang] }}
    </div>
    <div class="row justify-center">
      <div class="thumbs down" :class="{ thumbs_selected: value === 0 }" ref="thumb_0" @click="selectThumb(0)">
        <i
          class="thumb-icon"
          :class="[value !== 0 && !thumbsDownHover ? 'icon-thumbsDown-outlined' : 'icon-thumbsDown-filled']"
          @mouseover="thumbsDownHover = true"
          @mouseout="thumbsDownHover = false"
        />
      </div>
      <div class="thumbs up" :class="{ thumbs_selected: value === 1 }" ref="thumb_1" @click="selectThumb(1)">
        <i
          class="thumb-icon"
          :class="[value !== 1 && !thumbsUpHover ? 'icon-thumbsUp-outlined' : 'icon-thumbsUp-filled']"
          @mouseover="thumbsUpHover = true"
          @mouseout="thumbsUpHover = false"
        />
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import getUserContextByMetric from "@/utils/getUserContextByMetric";
export default {
  components: {},
  props: {
    questionData: {
      type: Object
    },
    onSelectAnswer: {
      type: Function,
      default: () => {}
    },
    lang: {
      type: String,
      default: "pt_BR"
    },
    color: {
      type: String
    },
    children: Boolean
  },
  data() {
    return {
      value: null,
      thumbsUpHover: false,
      thumbsDownHover: false
    };
  },
  methods: {
    selectItem: _.debounce(function (value) {
      const response = {
        uuid: this.questionData.item_uuid,
        type: this.questionData.type,
        answer: {
          response: value,
          comment: this.comment,
          context: getUserContextByMetric(this.questionData.type, value)
        }
      };
      this.onSelectAnswer(response);
    }, 250),
    selectThumb(value) {
      this.value = value;
      this.selectItem(value);
    }
  },
  mounted() {
    if (this.questionData.current_comment !== undefined) {
      this.comment = this.questionData.current_comment;
    }
    if (this.questionData.current_response !== undefined) {
      this.value = Number(this.questionData.current_response);
    }
    this.$watch("comment", () => this.selectItem(this.value));
  }
};
</script>
<style scoped>
.thumbs {
  margin-right: 20px;
  cursor: pointer;
}
.thumbs .thumb-icon {
  font-size: 32px;
  color: #656565;
}

.thumbs.up:hover .thumb-icon,
.thumbs.thumbs_selected.up .thumb-icon {
  color: #1bb934;
}
.thumbs.down:hover .thumb-icon,
.thumbs.thumbs_selected.down .thumb-icon {
  color: #ea575f;
}
.composite-title {
  font-size: 16px;
  line-height: 20px;
  color: #354052;
  margin: 0;
  display: flex;
  align-items: center;
}
</style>
